import instantsearch from 'instantsearch.js/dist/instantsearch.js';
import * as searcher from './searchWidgets'

const facets = ['Type', 'Topic', 'MaoriResourceTopic', 'Discipline', 'Year'];
const resultsPerPage = 5;
const userInput = '#fullKcSearchInput';
let search;
let resultCount;


/**
 * Set up and start the search on the knowledge center search page
 */
if ($(userInput).length) {
    initSearch();
}

function initSearch() {
    createSearch();
    initListeners();
    checkInput();
    checkSort();
}


/**
 * Create and start a filtered InstantSearch search
 */
function createSearch() {
    search = searcher.getSearch('KnowledgePopular', resultsPerPage, true);
    search.addWidget(
        searcher.widgetInput(userInput, function(){checkSort()})
    );
    search.addWidget(
        searcher.widgetHits('#kcSearchResults', function(){checkResultCount();})
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetType  .filter__sort', 'Type')
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetTopic  .filter__sort', 'Topic')
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetMaoriResourceTopic  .filter__sort', 'MaoriResourceTopic')
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetDiscipline  .filter__sort', 'Discipline')
    );
    search.addWidget(
        searcher.widgetNumericRefinementList('#facetYear .filter__sort')
    );
    search.start();
}


/**
 * Sets up listeners for various sections of the search page to
 * give a more interactive and useful search experience.
 */
function initListeners() {
    // display most recent index results
    $('#sort-most-recent').change(function() {
        search.helper.state.index = searcher.getIndex('KnowledgeRecent');
        search.helper.search();
        $('#filter__sort').text('Most Recent');
    });

    // display most popular index results
    $('#sort-most-popular').change(function() {
        search.helper.state.index = searcher.getIndex('KnowledgePopular');
        search.helper.search();
        $('#filter__sort').text('Most Popular');
    });

    // display most relevant index results
    $('#sort-most-relevant').change(function() {
        search.helper.state.index = searcher.getIndex('KnowledgeRelevant');
        search.helper.search();
        $('#filter__sort').text('Most Relevant');
    });

    // see more button with max results
    $('#seeMoreBtn').click(function(e) {
        search.helper.state.hitsPerPage += resultsPerPage;
        search.helper.search();
        checkResultCount();
        e.preventDefault();
    });

    search.on('render', function() {
        checkResultCount();
    });
}


/**
 * Checks for existing input such as filtering or search terms to apply.
 * This is intended to be called after creating a search, and is
 * usually useful when directed from another page. Eg: on selecting all
 * report results from the knowledge centre drop search.
 */
function checkInput() {
    let activeFilters = search.helper.state.disjunctiveFacetsRefinements;
    let activeYear = search.helper.state.numericRefinements;
    let activeInput = search.helper.getQuery().query;

    // default display most relevant if text input exists
    if (activeInput) {
        $(userInput).val(activeInput);
        $('#sort-most-relevant').prop('checked', true);
        $('#sort-most-relevant').change();
        $('#filter__sort').next().addClass('filter__active');
        $('#filter__sort').addClass('filter__active--arrow');
    }

    // default display filtering section if there is an active filter
    if (!$.isEmptyObject(activeFilters) || !$.isEmptyObject(activeYear)) {
        for (let i = 0; i < facets.length; i++) {
            if (activeFilters[facets[i]]) {
                let filterId = '#filter__' + facets[i].toLowerCase();
                $(filterId).next().addClass('filter__active');
                $(filterId).addClass('filter__active--arrow');
            }
        }
    }
    if (!$.isEmptyObject(activeYear)) {
        $('#filter__year').next().addClass('filter__active');
        $('#filter__year').addClass('filter__active--arrow');
    }
}


/**
 * Show/hide the show more button when appropriate.
 */
function checkResultCount() {
    if (search.helper.lastResults) {
        resultCount = search.helper.lastResults.nbHits;
    }

    if ((!resultCount && search.helper.lastResults) ||
        search.helper.state.hitsPerPage >= resultCount) {
            $('#seeMoreBtn').css('display', 'none');
    } else {
        $('#seeMoreBtn').css('display', 'block');
    }

    $('#search__count').html(`
        <h3>${search.helper.lastResults.nbHits} results found</h3>
        <div>Refine your search by using the filters.</div>
    `);
}


/**
 * Shows/hides and selects the sort by options depending on user
 * input. Eg: Blank input can not have a 'most relevant' results.
 */
function checkSort() {
    let searchValue = $(userInput).val();
    if (searchValue) {
        if (searchValue.length) {
            $('#sort-most-relevant').prop('checked', true);
            $('#sort-most-relevant').change();
        }
        $('#mostRel').css('display', 'block');
    } else {
        if ($('#sort-most-relevant').prop('checked')) {
            $('#sort-most-popular').prop('checked', true);
            $('#sort-most-popular').change();
        }
        $('#mostRel').css('display', 'none');
    }
}



// WEBPACK FOOTER //
// ./src/js/search/knowledgeCentreSearch.js